import { useFilterParam } from '@occc-app/hooks/useFilterParam';

import { ProgressOfferEligibilityFilter } from './in-progress-offers.types';
import {
  IN_PROGRESS_OFFERS_ELIGIBILITY_PARAM,
  IN_PROGRESS_OFFERS_AFTER_PARAM,
  IN_PROGRESS_OFFERS_BEFORE_PARAM,
} from '../../../constants';

const VALID_VALUES = ['eligible', 'ineligible'] as const;
const DEFAULT: ProgressOfferEligibilityFilter = 'eligible';

export const useProgressOffersEligibility = (): [
  ProgressOfferEligibilityFilter,
  (value: ProgressOfferEligibilityFilter) => void,
] => {
  return useFilterParam<ProgressOfferEligibilityFilter>(
    IN_PROGRESS_OFFERS_ELIGIBILITY_PARAM,
    DEFAULT,
    {
      validValues: VALID_VALUES,
      beforeParam: IN_PROGRESS_OFFERS_BEFORE_PARAM,
      afterParam: IN_PROGRESS_OFFERS_AFTER_PARAM,
    },
  );
};
